<mat-grid-list cols="1" rowHeight="50px">
    <mat-grid-tile>
        <span matLine>Bienvenido</span>
        <span matLine>{{perfil?.nombre}}</span>
        <span matLine>Rol:</span>
        <span matLine>
            @switch (perfil?.rol) {
                @case (1) {
                    Analista
                }
                @case (2) {
                    Supervisor
                }
                @case (3) {
                    Coordinador
                }
                @default {
                    Administrador
                }
            }
        </span>
    </mat-grid-tile>
    <mat-grid-tile>
        <span matLine>Version: </span>
        <span matLine>3.0.11</span>
    </mat-grid-tile>
    <mat-grid-tile>
        <button mat-flat-button color="primary" (click)="cerrarSesion($event)">CERRAR SESIÓN</button>
    </mat-grid-tile>
</mat-grid-list>